var map = {
	"./all-in-one-reviews/widget.vue": 494,
	"./cookie-banner-widget/widget.vue": 109,
	"./countdown-widget/widget.vue": 141,
	"./datatable-widget/widget.vue": 8835,
	"./faq-widget/widget.vue": 6031,
	"./floating-button-widget/widget.vue": 4903,
	"./image-comparison-slider/widget.vue": 2553,
	"./image-hotspot-widget/widget.vue": 7101,
	"./image-magnifier-widget/widget.vue": 8576,
	"./logo-showcase-widget/widget.vue": 6470,
	"./opening-hours-widget/widget.vue": 7721,
	"./poll-widget/widget.vue": 8806,
	"./pricing-table-widget/widget.vue": 304,
	"./qr-code-widget/widget.vue": 9481,
	"./quiz-widget/widget.vue": 8214,
	"./timeline-widget/widget.vue": 5720,
	"./universal-chat-widget/widget.vue": 178,
	"./whats-app-chat-widget/widget.vue": 126
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2868;